import { actionCopyIt } from "./actionCopy";
import { listCopyIt } from "./listCopy";

export const studiesCopyIt = {
    studies: "Studi",
    description: "Crei studi e inviti clinici con accessi, etichette e una fatturazione ricavati dai modelli.",
    unauthorizedMessage: "Gli studi sono riservati agli amministratori e ai responsabili.",
    searchPlaceholder: "Cercare studi, etichette, moduli o modelli",
    searchAriaLabel: "Cercare studi",
    clearSearchAria: actionCopyIt.clearSearch,
    filterStudiesAria: "Filtrare gli studi",
    studyFilterDescription: "Filtri gli studi per stato e per piano di fatturazione.",
    newStudy: "Nuovo studio",
    noStudiesYet: "Nessuno studio al momento. Crei il Suo primo studio per configurare gli accessi e gli inviti.",
    noStudiesMatchSearch: "Nessuno studio corrisponde alla Sua ricerca o ai Suoi filtri.",
    columnStudyName: "Nome dello studio",
    columnLabel: "Etichetta",
    columnForms: "Moduli",
    columnTemplates: "Modelli",
    columnPlan: "Piano",
    columnExpiry: "Scadenza",
    columnDiaries: "Diari",
    columnClinicians: "Clinici",
    columnStatus: listCopyIt.status,
    columnActions: listCopyIt.actions,
    published: listCopyIt.published,
    draft: listCopyIt.draft,
    open: actionCopyIt.open,
    invite: actionCopyIt.invite,
    edit: actionCopyIt.edit,
    openStudyAria: "Aprire lo studio",
    inviteStudyAria: "Invitare clinici a questo studio",
    editStudyAria: "Modificare lo studio",
    openTrackingAria: "Aprire i grafici di andamento dello studio",
    trackingDialogTitle: (studyName: string) => `Andamento · ${studyName}`,
    emptyLabel: " - ",
    templateCount: (count: number) => `${count} modell${count === 1 ? "o" : "i"}`,
    newStudyTitle: "Nuovo studio",
    newStudyDescription:
        "Scelga i modelli per ricavare gli accessi a eventi, moduli e calendari, quindi personalizzi i permessi, la fatturazione e le impostazioni di pubblicazione.",
    editStudyTitle: "Modificare lo studio",
    editStudyDescription:
        "Aggiorni i modelli, gli accessi ricavati, i permessi personalizzati, la fatturazione e la visibilità di questo studio per i responsabili.",
    studySaved: "Studio salvato",
    failedToSaveStudy: "Salvataggio dello studio non riuscito",
    saveStudy: "Salvare lo studio",
    saveChanges: "Salvare le modifiche",
    studyName: "Nome dello studio",
    studyNamePlaceholder: "ad es. Elite Tendon Knee 2026",
    labelAccess: "Accesso per etichetta",
    selectLabels: "Selezionare etichette",
    addLabel: "Aggiungere un'etichetta",
    labelName: "Nome dell'etichetta",
    labelNamePlaceholder: "ad es. Elite Tendon Knee",
    formAccess: "Accesso ai moduli",
    selectForms: "Selezionare moduli",
    templates: "Modelli",
    inferredAccessTitle: "Accessi ricavati dai modelli",
    inferredAccessDescription:
        "I questionari, i calendari e gli eventi richiesti dai modelli selezionati vengono concessi automaticamente.",
    inferredAccessEmpty: "Selezioni uno o più modelli per ricavare gli accessi dei clinici.",
    inferredEvents: "Eventi",
    inferredForms: "Questionari",
    inferredSchedules: "Calendari",
    inferredNone: "Nessuno",
    customiseAccessTitle: "Personalizzare gli accessi",
    customiseAccessHideTitle: "Nascondere le opzioni di accesso",
    customiseAccessDescription:
        "Controllo completo delle modalità e dei permessi privati. I questionari, i calendari e gli eventi richiesti dai modelli restano selezionati.",
    loadingAccessOptions: "Caricamento delle opzioni di accesso…",
    billingPlan: "Piano di fatturazione",
    selectPlan: "Selezionare un piano",
    expiryDate: "Data di scadenza",
    pickDate: "GG/MM/AAAA",
    expiryDateMinMessage: "La scadenza deve essere domani o successiva",
    expiryDateMaxMessage: "Restiamo entro i prossimi 100 anni",
    expiryDateInvalidMessage: "Questa data non sembra corretta",
    publishStudyForManagers: "Pubblicare lo studio",
    labelAccessSummary: "Accesso per etichetta",
    formAccessSummary: "Accesso ai moduli",
    templatesSummary: "Modelli",
    billingPlanSummary: "Piano di fatturazione",
    expirySummary: "Scadenza",
    statusSummary: "Stato",
    loadingStudy: "Caricamento dello studio…",
    studyNotFound: "Studio non trovato",
    backToStudies: "Tornare agli studi",
    studyInvite: "Invito allo studio",
    inviteToStudy: (studyName: string) => `Invitare allo studio ${studyName}`,
    inviteToStudyDescription:
        "Condivida un codice QR o un link affinché i clinici possano registrarsi e unirsi a questo studio. Può, se lo desidera, imporre un'organizzazione e una specialità.",
    inviteStepReview: "Verifica",
    inviteStepEmail: "E-mail",
    inviteStepQr: "Codice QR",
    inviteStepInvite: "Invito",
    generatingInviteLink: "Generazione del link di invito…",
    failedToCreateInviteLink: "Creazione del link di invito non riuscita",
    studyInviteQrDescription: (studyName: string) =>
        `Condivida un codice QR o un link affinché i clinici possano registrarsi e unirsi a ${studyName}. L'organizzazione e la specialità provengono dai valori predefiniti dello studio.`,
    joinStudyTitle: (studyName: string) => `Unirsi a ${studyName}`,
    optionalOrganisationSignupHint:
        "Facoltativo. Lasci vuoto affinché il clinico crei la propria organizzazione durante la configurazione iniziale.",
    clinicianWillChooseOrganisation:
        "Il clinico sceglierà o creerà la propria organizzazione al momento della registrazione.",
    specialty: "Specialità",
    optionalSuffix: "(facoltativo)",
    optionalSpecialtySignupHint:
        "Facoltativo. Se impostata, la specialità viene applicata ai clinici che si uniscono a questo studio.",
    selectSpecialtyPlaceholder: "Selezionare una specialità",
    clearSpecialty: "Cancellare",
    clinicianInviteDefaultsTitle: "Valori predefiniti dell'invito dei clinici",
    clinicianInviteDefaultsDescription:
        "Può imporre un'organizzazione e una specialità ai clinici che si uniscono a questo studio tramite un codice QR o un link di invito.",
    defaultOrganisation: "Organizzazione",
    noOrganisationsAvailable: "Nessuna organizzazione disponibile da selezionare.",
    inviteDefaultsSummary: (summary: string) => `Valori predefiniti dell'invito: ${summary}`,
    inviteDefaultsEmpty:
        "Nessuna organizzazione né specialità imposta per questo studio. I clinici le indicano durante la configurazione iniziale.",
    emailRequired: "L'indirizzo e-mail è obbligatorio",
    validEmailRequired: "Inserisca un indirizzo e-mail valido",
    studyInviteEmailSent: "E-mail di invito allo studio inviata",
    failedToSendInvite: "Invio dell'invito non riuscito",
    trackingTitle: "Monitoraggio dello studio",
    trackingDescription: "I clinici con le etichette di questo studio e i diari che hanno creato.",
    trackingLabelsHint: "Etichette",
    trackingLoading: "Caricamento del monitoraggio…",
    trackingError: "Impossibile caricare il monitoraggio dello studio.",
    trackingNoLabels: "Aggiunga etichette a questo studio per monitorare i clinici e i diari.",
    trackingNoClinicians: "Nessun clinico ha ancora queste etichette.",
    trackingNoDiaries: "Nessun diario è ancora stato etichettato per questo studio.",
    trackingCliniciansWithAccess: "Clinici con accesso",
    trackingCliniciansHint: (members: number, withLabels: number) =>
        `${members} membr${members === 1 ? "o" : "i"} dello studio · ${withLabels} con accesso per etichetta`,
    trackingTotalDiaries: "Diari",
    trackingAvgDiariesPerClinician: "Media diari / clinico",
    trackingCliniciansWithDiaries: "Clinici con diari",
    trackingDiariesPerClinician: "Diari per clinico",
    trackingCumulativeDiaries: "Diari cumulativi",
    trackingClinicianTableTitle: "Clinici",
    trackingColumnClinician: "Clinico",
    trackingColumnDiaries: "Diari",
    trackingColumnAccess: "Accesso",
    trackingAccessMember: "Membro dello studio",
    trackingAccessLabel: "Accesso per etichetta",
    trackingAccessDiaryOnly: "Solo diari",
    trackingCliniciansShort: "clinici",
    trackingNoLabelsShort: "Nessuna etichetta",
    trackingNoDiariesShort: "Nessun diario al momento",
};
